module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-introduction element-with-heading",
    attrs: {
      "id": "introduction"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "introduction-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "introduction-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("A hostile takeover is the acquisition of one company (called the target company) by another (called the acquirer) that is accomplished by going directly to the company's shareholders or fighting to replace management to get the acquisition approved. A hostile takeover can be accomplished through either a tender offer or a proxy fight.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('b', [_vm._v("Hostile")]), _vm._v(" (adjective): warlike, aggressive"), _c('i', [_vm._v(";")]), _vm._v(" adverse, contrary, unsympathetic.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('b', [_vm._v("Takeover")]), _vm._v(" (noun):")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_vm._v("1. ")]), _vm._v("the act of seizing or appropriating authority or control.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" the acquisition of a corporation through the purchase or exchange of stock.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddb4def","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 78
// module chunks = 0